export default __webpack_public_path__ + "static/media/alarm.ed059d3c.svg";